<template>
  <div>
    <div v-if="!loaded" style="text-align:center; margin:100px;">
      <loading-spinner :loading="!loaded"></loading-spinner>
    </div>
    <table v-else class="table table-no-border  table-responsive-md">
      <tbody>
        <tr>
          <th style="width:33%"><h4 class="text-pink bold text-center">FEMALE</h4></th>
          <th style="width:33%"></th>
          <th style="width:33%"><h4 class="text-lblue bold text-center">MALE</h4></th>
        </tr>
        <!-- APPRENTICE 6 -->
        <tr>
          <td style="width:33%">
            <div class="progress">
              <div class="progress-bar progress-bar-reverse bg-pink" role="progressbar" :style="{'width': genders[6].females_pct}">{{ genders[6].females_pct }}</div>
            </div>
          </td>
          <td style="width:33%" class="text-center"><b>APPRENTICE</b></td>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar bg-lblue" role="progressbar" :style="{'width': genders[6].males_pct}">{{ genders[6].males_pct }}</div>
            </div>
          </td>
        </tr>
        <!--  GREEN 7 -->
        <tr>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar progress-bar-reverse bg-pink" role="progressbar" :style="{'width': genders[7].females_pct}">{{ genders[7].females_pct }}</div>
            </div>
          </td>
          <td style="width:33%" class="text-lime text-center"><b>GREEN</b></td>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar bg-lblue" role="progressbar" :style="{'width': genders[7].males_pct}">{{ genders[7].males_pct }}</div>
            </div>
          </td>
        </tr>
        <!-- SILVER 8 -->
        <tr>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar progress-bar-reverse bg-pink" role="progressbar" :style="{'width': genders[8].females_pct}">{{ genders[8].females_pct }}</div>
            </div>
          </td>
          <td style="width:33%" class="text-grey text-center"><b>SILVER</b></td>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar bg-lblue" role="progressbar" :style="{'width': genders[8].males_pct}">{{ genders[8].males_pct }}</div>
            </div>
          </td>
        </tr>
        <!-- GOLD 9 -->
        <tr>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar progress-bar-reverse bg-pink" role="progressbar" :style="{'width': genders[9].females_pct}">{{ genders[9].females_pct }}</div>
            </div>
          </td>
          <td style="width:33%" class="text-gold text-center"><b>GOLD</b></td>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar bg-lblue" role="progressbar" :style="{'width': genders[9].males_pct}">{{ genders[9].males_pct }}</div>
            </div>
          </td>
        </tr>
        <!-- PLATINUM 10 -->
        <tr>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar progress-bar-reverse bg-pink" role="progressbar" :style="{'width': genders[10].females_pct}">{{ genders[10].females_pct }}</div>
            </div>
          </td>
          <td style="width:33%" class="text-grey text-center"><b>PLATINUM</b></td>
          <td style="width:33%">
            <div class="progress progress-middle-out">
              <div class="progress-bar bg-lblue" role="progressbar" :style="{'width': genders[10].males_pct}">{{ genders[10].males_pct }}</div>
            </div>
          </td>
        </tr>
        <tr>
          <td style="width:33%" class=" text-pink text-center">{{ genders.totals.females_pct }}</td>
          <td style="width:33%" class=" text-center"><b>TOTAL</b></td>
          <td style="width:33%" class=" text-lblue text-center">{{ genders.totals.males_pct }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
export default {
  name: 'GenderEnrolments',
  data () {
    return {
      loaded: false,
      genders: []
    };
  },
  methods: {
    loadGenders () {
      {
        this.axios.get('/statistics/genders').then((rsp) => {
          const totals = {
            females: 0,
            females_pct: '0%',
            males: 0,
            males_pct: '0%'
          };
          for (let key of Object.keys(rsp.data)) {
            let role = rsp.data[key];
            role.females = parseInt(role.females, 10);
            role.males = parseInt(role.males, 10);
            role.sum = role.females + role.males;
            role.females_pct = (!role.females || !role.sum)
                ? '0.00%'
                : (role.females / role.sum * 100).toFixed(2) + '%';
            role.males_pct = (!role.males || !role.sum)
                ? '0.00%'
                : (role.males / role.sum * 100).toFixed(2) + '%';
            totals.females += role.females;
            totals.males += role.males;
          }
          totals.sum = totals.females + totals.males;
          totals.females_pct = (!totals.females || !totals.sum)
              ? '0.00%'
              : (totals.females / totals.sum * 100).toFixed(2) + '%';
          totals.males_pct = (!totals.males || !totals.sum)
              ? '0.00%'
              : (totals.males / totals.sum * 100).toFixed(2) + '%';
          rsp.data.totals = totals;
          this.genders = rsp.data;
          this.loaded = true;
        }).catch(err => this.$errorOut(err));
      }
    }
  },
  mounted () {
    this.loadGenders();
  }
};
</script>
